import React, { useLayoutEffect, useEffect, useState } from 'react';

export const useScrollCheck = (
  ref: React.RefObject<HTMLElement>
): {
  isScrolled: boolean;
  isScrollable: boolean;
  scrollCheckProps: { onScroll: () => void };
} => {
  const [isScrollable, setScrollable] = useState(false);
  const [isScrolled, setScrolled] = useState(false);

  const onScroll = () => {
    if (ref.current?.scrollTop === 0) {
      setScrolled(false);
    } else {
      setScrolled(true);
    }
  };

  useLayoutEffect(() => {
    const bodyElement = ref.current;
    /**
     * ResizeObserver is not supported by IE but there is a polyfill for it
     * https://www.npmjs.com/package/resize-observer-polyfill
     * https://github.com/que-etc/resize-observer-polyfill
     * so it is safe to use it, in case we need to support IE as well.
     */
    const resizeObserver = new ResizeObserver(() => {
      if (bodyElement) {
        setScrollable(bodyElement?.scrollHeight > bodyElement.offsetHeight);
      }
    });
    if (bodyElement) {
      resizeObserver.observe(bodyElement);
    }
    return () => {
      if (bodyElement) {
        resizeObserver.unobserve(bodyElement);
      }
    };
  }, []);

  useEffect(() => {
    if (ref.current) {
      setScrollable(ref.current?.scrollHeight > ref.current.offsetHeight);
    }
  });

  return { isScrollable, isScrolled, scrollCheckProps: { onScroll } };
};
